module.exports = __webpack_public_path__ + "img/&.384bc148.svg";